import React, { useState, useEffect } from 'react';
import AdminLayout from './AdminLayout';
import ImageUploader from './ImageUploader';
import RichTextEditor from './RichTextEditor';
import Toast from './Toast';
import { getSections, updateSection } from '../../services/api';
import { triggerDataRefresh } from '../../context/SiteDataContext';
import './admin.css';

const ServiceDeRelectureEditor = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [toast, setToast] = useState(null);

  const [formData, setFormData] = useState({
    id: 'main-servicederelecture',
    image: 'assets/images/open_book.jpg',
    title: 'Service',
    subtitle: 'Service de relecture',
    description: '<p>Besoin d\'une relecture professionnelle ?</p>',
  });

  useEffect(() => {
    loadConfig();
  }, []);

  const loadConfig = async () => {
    try {
      const response = await getSections(true);
      const config = response.serviceDeRelectureConfig;
      if (config) {
        setFormData({
          id: config.id || 'main-servicederelecture',
          image: config.image || 'assets/images/open_book.jpg',
          title: config.title || 'Service',
          subtitle: config.subtitle || 'Service de relecture',
          description: config.description || '<p>Besoin d\'une relecture professionnelle ?</p>',
        });
      }
    } catch (err) {
      setToast({ message: err.message, type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setToast(null);
    setSaving(true);

    try {
      await updateSection(formData.id || 'main-servicederelecture', 'serviceDeRelectureConfig', formData);
      setToast({ message: '✓ Service de relecture enregistré !', type: 'success' });
      triggerDataRefresh();
    } catch (err) {
      setToast({ message: err.message || 'Erreur lors de l\'enregistrement', type: 'error' });
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <AdminLayout>
        <div className="admin-loading">
          <div className="spinner"></div>
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div className="admin-page">
        <header className="admin-page-header">
          <div>
            <h1>Service de relecture</h1>
            <p>Modifier le contenu de la section service de relecture</p>
          </div>
        </header>

        {toast && (
          <Toast
            message={toast.message}
            type={toast.type}
            onClose={() => setToast(null)}
          />
        )}

        <form onSubmit={handleSubmit} className="admin-form">
          <div className="admin-form-grid">
            <div className="admin-form-group">
              <label>Nom (petit label en haut)</label>
              <input
                type="text"
                value={formData.title}
                onChange={(e) => handleChange('title', e.target.value)}
                placeholder="Service"
              />
            </div>

            <div className="admin-form-group">
              <label>Titre principal (sous la ligne)</label>
              <input
                type="text"
                value={formData.subtitle}
                onChange={(e) => handleChange('subtitle', e.target.value)}
                placeholder="Service de relecture"
              />
            </div>

            <div className="admin-form-group full-width">
              <label>Zone de texte (description complète)</label>
              <RichTextEditor
                value={formData.description}
                onChange={(value) => handleChange('description', value)}
                placeholder="Description du service de relecture..."
              />
            </div>

            <div className="admin-form-group full-width">
              <label>Image</label>
              <ImageUploader
                currentImage={formData.image}
                onUpload={(url) => handleChange('image', url)}
              />
            </div>
          </div>

          <div className="admin-form-actions">
            <button
              type="submit"
              className="admin-btn admin-btn-primary"
              disabled={saving}
            >
              {saving ? 'Enregistrement...' : 'Enregistrer'}
            </button>
          </div>
        </form>
      </div>
    </AdminLayout>
  );
};

export default ServiceDeRelectureEditor;
